module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Part01"
    }
  }, [_c('p', {
    staticClass: "pt-num"
  }, [_vm._v("P A R T   O N E"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page15"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pt-title"
  }, [_vm._v("The German Auxiliary Cruiser "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Guerre de Course")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Recognising the importance to Britain of imported goods, the Imperial German Navy set a strategic goal to disrupt and destroy British trade. To accomplish such a task, the planners acknowledged that their limited number of appropriate vessels, essentially long-range cruisers, was insufficient. Thus they looked for other solutions. Britain, too, had a strategic imperative to disrupt and deny German trade; but first she had to determine the appropriate tactics."), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page16"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc284e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Part01.vue
// module id = 87
// module chunks = 0